import { Navigate } from "react-router-dom";

import Dashboard from "pages/Dashboard";
import { APP_URLS } from "settings";
import { useUserStore } from "store/User";

/**
 * Component that handles users specific dashboards
 */
export default function RoleDashboard() {
  const user = useUserStore((state) => state.user);

  // Redirect ADMIN users to the Case Listing page
  if (user?.isAdmin) {
    return <Navigate replace to={APP_URLS.CASE_MANAGEMENT} />;
  }

  // All other users view the default dashboard
  return <Dashboard />;
}
